import commonConfig from "./common.config";

export default {
  ...commonConfig,
  onecarePushkey: 'BM3MxIRu28xJIcIs76BlsH7cPM17pBZwMMAcvq1gQMGgaDnA3PzZ5vgndhNtoFQPIon__LFTQqRF80Z6AHNjGzs',
  vikandDirectPushkey: 'BCC9TlmesdLmBIYUUYhhu8Df0angc2g6tf8zY9BlUnvQavMYrrAp9ZnsKz_UzQ-aC1_EOEtg4JQMqjNPuKc-t-g',
  onshipPushkey: 'BPpdtKdM-aTcVL4i2Z5ccHeOnLJbZaozItAv2UR0_C08r_kLVswJVo5W1HYat3Kl58PLtRgwhSEcEB8Fubv2T2M',
  vikandTestPushkey: 'BB-4KG_6eHYLLLnaamkGXntHCLuPUC1jh5Iz2CRIJtBVN1T9StH89ZgKr7bUnR3BrFrsGVDWpESOWdFbk-yeSFk',
  bemPushKey: 'BDbqwDhV7Ol1EL-UGuMCjLL7OB2wV4W19bqUStbeF2wReCsQF_bEJDmg25GCIMg10QYpMj2zX9wu-YGlrW_xHeY',
  onshipWebPushAppType: "onship",
  vikandWebPushAppType: "vikand",
  onecareWebPushAppType: "onecare",
  vikandTestWebPushAppType: "vikand_test",
  bemWebPushAppType: "bem"
};
